// extracted by mini-css-extract-plugin
module.exports = {"Spectacles":"spectacles_Spectacles__2Gvmz"};